import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("palumbo_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;

export function cleanWaNumber(n) {
  if (!n) return "";
  let d = String(n).replace(/\D/g, "");
  if (d.startsWith("00")) d = d.slice(2);
  // If looks like an Italian mobile without country code, prepend 39
  if (d.length >= 9 && d.length <= 10 && !d.startsWith("39")) d = "39" + d;
  return d;
}

export function waLink(n, text) {
  const num = cleanWaNumber(n);
  if (!num) return "#";
  const params = new URLSearchParams({ phone: num });
  if (text) params.set("text", text);
  return `https://api.whatsapp.com/send?${params.toString()}`;
}

export function formatApiError(detail) {
  if (detail == null) return "Errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
